// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Eq","link":"e_Fq","imageContainer":"e_Gq","author":"e_Hq","text":"e_Iq","buttonIcon":"e_Jq"};